import { render, staticRenderFns } from "./PlanilhaAlertas.vue?vue&type=template&id=1479bac0&scoped=true"
import script from "./PlanilhaAlertas.vue?vue&type=script&lang=js"
export * from "./PlanilhaAlertas.vue?vue&type=script&lang=js"
import style0 from "./PlanilhaAlertas.vue?vue&type=style&index=0&id=1479bac0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479bac0",
  null
  
)

export default component.exports